import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

export const operationInputClass =
  'w-full rounded-lg border px-4 py-2.5 text-sm outline-none transition-colors ' +
  'placeholder:text-[#999] focus:border-[#6B0F1A] focus:ring-1 focus:ring-[#6B0F1A] ' +
  'disabled:cursor-not-allowed disabled:bg-[#f5f5f5] disabled:text-[#777]';

export interface OperationFieldProps {
  id: string;
  label: string;
  required?: boolean;
  error?: string;
  children: ReactNode;
  className?: string;
}

export function OperationField({
  id,
  label,
  required,
  error,
  children,
  className,
}: OperationFieldProps) {
  return (
    <div className={className}>
      <label
        htmlFor={id}
        className="mb-1.5 block text-[11px] font-semibold uppercase tracking-wide text-[#666]"
      >
        {label}
        {required ? ' *' : ''}
      </label>
      {children}
      {error && (
        <p className="mt-1.5 text-xs text-[#c62828]" role="alert">
          {error}
        </p>
      )}
    </div>
  );
}

export function fieldBorderClass(hasError: boolean): string {
  return cn(operationInputClass, hasError ? 'border-[#c62828]' : 'border-[#e0e0e0]');
}
